import { useState } from "react";
import { Link as LinkIcon, Plus, X } from "lucide-react";
import LotPickerL2 from "@/components/crm/LotPickerL2";

const GREEN = "#5DCAA5";

/** iter410 L6 / iter419 pt 1-2 — « LOT LIÉ · FACULTATIF » : pour les types SANS lot obligatoire. Un document peut être lié à PLUSIEURS lots
 *  (`values` = tableau d'ids) : une carte par lot + « Ajouter un lot » (même LotPickerL2, choix multiple, lots déjà liés cochés). */
export default function OptionalLotSection({ lots = [], values = [], onChange, projectId, projectName = "", suggestNo = "", onOpenChange, testId = "doc-optional-lot" }) {
  const [picking, setPicking] = useState(false);
  const [hint, setHint] = useState(false);
  const linked = values.map((id) => lots.find((l) => l.id === id) || { id, numero: "?" });
  const toggle = (id) => { if (!id) return; onChange(values.includes(id) ? values.filter((v) => v !== id) : [...values, id]); };
  const startPicking = () => { if (!projectId) { setHint(true); return; } setHint(false); setPicking(true); };
  const Card = ({ lot }) => {
    const meta = [projectName, lot?.block_name && `Bloc ${lot.block_name}`, lot?.surface && `${lot.surface} m²`].filter(Boolean).join(" · ");
    return (
      <div className="flex items-center" style={{ gap: 10, background: "#12291F", border: "1px solid #2A9A7A", borderRadius: 10, padding: "8px 12px" }} data-testid={`${testId}-card`} data-lot={lot.id}>
        <LinkIcon size={14} style={{ color: GREEN, flexShrink: 0 }} />
        <div className="min-w-0 flex-1">
          <div style={{ fontSize: 12.5, fontWeight: 600, color: "#E8E8EC" }} data-testid={`${testId}-card-title`}>Lot {lot.numero}{lot.type || lot.typology_label ? ` · ${lot.typology_label || lot.type}` : ""}</div>
          {meta && <div style={{ fontSize: 11, color: "#8FD9BD" }} data-testid={`${testId}-card-meta`}>{meta}</div>}
        </div>
        <button type="button" onClick={() => toggle(lot.id)} title="Retirer" className="inline-flex" style={{ color: "#EF4444" }} data-testid={`${testId}-remove-${lot.numero}`}><X size={14} /></button>
      </div>
    );
  };
  return (
    <div data-testid={testId} data-lots={values.join(",") || undefined} className="space-y-2">
      <div className="flex items-center gap-2">
        <div className="text-[11px] font-semibold uppercase tracking-[0.14em] shrink-0" style={{ color: GREEN }}>Lot lié · facultatif{values.length > 1 ? ` · ${values.length}` : ""}</div>
        <div className="h-px flex-1" style={{ background: `linear-gradient(90deg, ${GREEN}66, transparent)` }} />
      </div>
      {linked.map((lot) => <Card key={lot.id} lot={lot} />)}
      {picking ? (
        <div className="space-y-1.5" data-testid={`${testId}-picking`}>
          <LotPickerL2 lots={lots} value="" onChange={toggle} multi selectedIds={values} autoOpen suggestNo={suggestNo} placeholder="Lot, client, type… (un clic = ajouter / retirer)" onOpenChange={(o) => { onOpenChange?.(o); if (!o) setPicking(false); }} testId={`${testId}-picker`} />
          <div className="flex justify-end"><button type="button" onClick={() => setPicking(false)} style={{ fontSize: 11.5, fontWeight: 600, color: "#8CC4FF" }} data-testid={`${testId}-done`}>Terminer</button></div>
        </div>
      ) : (
        <button type="button" onClick={startPicking} className="inline-flex items-center justify-center w-full" style={{ gap: 6, height: 36, borderRadius: 9, border: "1px dashed #2D4A7A", color: "#8CC4FF", fontSize: 12, fontWeight: 500, background: "transparent" }} data-testid={values.length ? `${testId}-add` : `${testId}-link`}>
          {values.length ? <><Plus size={13} />Ajouter un lot</> : <><LinkIcon size={13} />Lier à un lot</>}
        </button>
      )}
      {hint && !projectId && <div style={{ fontSize: 11.5, color: "#E0A42E" }} data-testid={`${testId}-hint`}>Choisissez d'abord le siège / projet (section « Détails ») pour voir ses lots.</div>}
    </div>
  );
}
